import { WEEK_DAYS } from '../constants';

export function CalendarSkeleton() {
  const skeletonDays = Array.from({ length: 35 }, (_, i) => i);

  return (
    <div className="w-full max-w-6xl mx-auto bg-background">
      <style>{`
        @keyframes colorFlicker {
          0%, 100% {
            background-color: rgb(228, 228, 231);
            opacity: 0.5;
          }
          25% {
            background-color: rgb(196, 181, 253);
            opacity: 0.6;
          }
          50% {
            background-color: rgb(191, 219, 254);
            opacity: 0.7;
          }
          75% {
            background-color: rgb(254, 202, 202);
            opacity: 0.6;
          }
        }
        .skeleton-post {
          animation: colorFlicker 2.5s ease-in-out infinite;
        }
      `}</style>
      <div className="border rounded-lg overflow-hidden bg-card">
        <div className="flex items-center justify-between p-3 border-b">
          <div className="flex items-center gap-2">
            <div className="h-7 w-48 bg-muted rounded"></div>
          </div>
          <div className="flex items-center gap-3">
            <div className="h-5 w-32 bg-muted rounded"></div>
            <div className="h-8 w-20 bg-muted rounded"></div>
          </div>
        </div>

        <div className="max-h-[600px] overflow-hidden">
          <div className="px-4 py-2 bg-muted/50">
            <div className="h-5 w-32 bg-muted rounded"></div>
          </div>

          <div className="grid grid-cols-7">
            {WEEK_DAYS.map(day => (
              <div
                key={day}
                className="bg-muted p-3 text-center text-sm font-semibold text-foreground border-r border-b last:border-r-0"
              >
                {day}
              </div>
            ))}

            {skeletonDays.map((idx) => (
              <div
                key={idx}
                className="min-h-[100px] border-r border-b last:border-r-0 p-2 bg-background"
              >
                <div className="text-sm font-medium mb-2 h-5 w-6 bg-muted rounded"></div>
                {idx % 3 === 0 && (
                  <div className="space-y-1.5">
                    <div className="h-12 skeleton-post rounded-md" style={{ animationDelay: `${idx * 0.08}s` }}></div>
                  </div>
                )}
                {idx % 5 === 0 && idx % 3 !== 0 && (
                  <div className="space-y-1.5">
                    <div className="h-12 skeleton-post rounded-md" style={{ animationDelay: `${idx * 0.08}s` }}></div>
                    <div className="h-12 skeleton-post rounded-md" style={{ animationDelay: `${(idx + 1) * 0.08}s` }}></div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
